<glxy-page [isLoading]="isLoading() || isSubmitting()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true" />
    </glxy-page-nav>
    <glxy-page-title>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.TITLE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'narrow'">
    @if (form(); as form) {
      <div [formGroup]="form">
        <!-- Name -->
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.NAME' | translate }}</glxy-label>
          <input type="text" matInput formControlName="name" />
        </glxy-form-field>

        <!-- Description -->
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.DESCRIPTION' | translate }}</glxy-label>
          <input type="text" matInput formControlName="description" />
        </glxy-form-field>

        <!-- Prompt module  -->
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.PROMPT' | translate }}</glxy-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="5"
            cdkAutosizeMaxRows="20"
            formControlName="prompt"
          ></textarea>
        </glxy-form-field>

        <!-- Functions -->
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.FUNCTIONS' | translate }}</glxy-label>
          <div class="cards-list">
            <ai-functions-list
              [functions]="functions()"
              (edit)="editFunction($event)"
              (remove)="removeFunction($event)"
            ></ai-functions-list>
            <mat-card class="add-button" (click)="openFunctionsModal()">
              <mat-card-content>{{ 'AI_ASSISTANT.GOALS.CONFIGURE_GOAL.ADD_FUNCTION' | translate }}</mat-card-content>
            </mat-card>
          </div>
        </glxy-form-field>
      </div>

      <ai-sticky-footer (submitClick)="submit()" (cancelClick)="cancel()" [disabled]="!canSave()"></ai-sticky-footer>
    }
  </glxy-page-wrapper>
</glxy-page>
